import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { Button } from "reactstrap";

const UnirPDF = () => {
    const navigate = useNavigate();
    const [archivos, setArchivos] = useState([]);
    const [cargando, setCargando] = useState(false);
    const [mensaje, setMensaje] = useState("");
    const [error, setError] = useState("");


    const tokenJ = localStorage.getItem("tokenJWT");

    //console.log("Token JWT:", tokenJ);

    useEffect(() => {
        if (!tokenJ) {
            navigate("/");
            //alert("Acceso denegado. Por favor, inicie sesión.");
        }
    }, []);



    // Seleccionar múltiples PDFs
    // Seleccionar múltiples PDFs
    const handleSeleccionarArchivos = (e) => {
        const seleccionados = Array.from(e.target.files);

        const pdfsValidos = seleccionados.filter(
            (archivo) =>
                archivo.type === "application/pdf" ||
                archivo.name.toLowerCase().endsWith(".pdf")
        );

        if (pdfsValidos.length !== seleccionados.length) {
            setError("Solo se permiten archivos PDF.");
        } else {
            setError("");
        }

        // ACUMULAR EN LUGAR DE REEMPLAZAR:
        setArchivos((prevArchivos) => [...prevArchivos, ...pdfsValidos]);

        setMensaje("");

        // Opcional: Limpiar el valor del input para permitir volver a seleccionar el mismo archivo si fue eliminado
        e.target.value = "";
    };

    // Eliminar archivo
    const eliminarArchivo = (indice) => {
        setArchivos((prev) =>
            prev.filter((_, i) => i !== indice)
        );
    };

    // Mover arriba
    const moverArriba = (indice) => {
        if (indice === 0) return;

        setArchivos((prev) => {
            const copia = [...prev];

            [copia[indice - 1], copia[indice]] = [
                copia[indice],
                copia[indice - 1],
            ];

            return copia;
        });
    };

    // Mover abajo
    const moverAbajo = (indice) => {
        if (indice === archivos.length - 1) return;

        setArchivos((prev) => {
            const copia = [...prev];

            [copia[indice], copia[indice + 1]] = [
                copia[indice + 1],
                copia[indice],
            ];

            return copia;
        });
    };

    // Unir PDFs
    const unirPDF = async () => {
        if (archivos.length === 0) {
            setError("Debes seleccionar al menos un archivo PDF.");
            return;
        }

        try {
            setCargando(true);
            setError("");
            setMensaje("Uniendo archivos PDF...");

            const formData = new FormData();

            archivos.forEach((archivo) => {
                formData.append("files", archivo);
            });

            const respuesta = await axios.post(
                "https://wwwp.isepsantafe.net.ar/expedientes/unir-todo-reduciendo-dos",
                formData,
                {
                    responseType: "blob",
                    timeout: 0,
                }
            );

            const blob = new Blob(
                [respuesta.data],
                {
                    type: "application/pdf",
                }
            );

            const url = window.URL.createObjectURL(blob);

            const enlace = document.createElement("a");

            enlace.href = url;
            enlace.download = "pdf_unido.pdf";

            document.body.appendChild(enlace);
            enlace.click();
            enlace.remove();

            window.URL.revokeObjectURL(url);

            const totalPaginas =
                respuesta.headers["x-total-pages"];

            if (totalPaginas) {
                setMensaje(
                    `PDF generado correctamente. ${totalPaginas} páginas.`
                );
            } else {
                setMensaje(
                    "PDF generado correctamente."
                );
            }

        } catch (err) {
            console.error("Error al unir PDF:", err);

            let mensajeError =
                "No se pudo generar el PDF.";

            if (err.response) {
                try {
                    const texto =
                        await err.response.data.text();

                    try {
                        const json = JSON.parse(texto);

                        if (json.detail) {
                            mensajeError = json.detail;
                        }
                    } catch {
                        if (texto) {
                            mensajeError = texto;
                        }
                    }
                } catch {
                    // Mantener mensaje genérico
                }
            } else if (err.message) {
                mensajeError = err.message;
            }

            setError(mensajeError);
            setMensaje("");

        } finally {
            setCargando(false);
        }
    };

    // Limpiar
    const limpiar = () => {
        setArchivos([]);
        setMensaje("");
        setError("");
    };


    const volver = () => {
        navigate('/consultaExpediente');
    }

    return (
        <div
            style={{
                maxWidth: "900px",
                margin: "30px auto",
                padding: "25px",
            }}
        >

            <h2>Unir PDF</h2>

            <p>
                Seleccioná varios archivos PDF para unirlos en un único documento.
                <br />
                <strong style={{ color: "#d32f2f", display: "block", marginTop: "8px" }}>
                    ⚠️ Atención: Si alguno de los archivos contiene firma digital, la misma perderá su validez jurídica al modificar o unir el documento.
                </strong>
            </p>

            {/* SELECCIONAR ARCHIVOS */}

            <div
                style={{
                    border: "2px dashed #aaa",
                    borderRadius: "10px",
                    padding: "30px",
                    textAlign: "center",
                    marginBottom: "20px",
                }}
            >
                <input
                    type="file"
                    accept="application/pdf,.pdf"
                    multiple
                    onChange={handleSeleccionarArchivos}
                />
            </div>

            {/* LISTA */}

            {archivos.length > 0 && (
                <div>

                    <h3>
                        Archivos seleccionados ({archivos.length})
                    </h3>

                    {archivos.map((archivo, indice) => (
                        <div
                            key={`${archivo.name}-${indice}`}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                padding: "12px",
                                marginBottom: "8px",
                                border: "1px solid #ddd",
                                borderRadius: "8px",
                                background: "#fafafa",
                            }}
                        >

                            <strong>
                                {indice + 1}.
                            </strong>

                            <div
                                style={{
                                    flex: 1,
                                    overflow: "hidden",
                                }}
                            >
                                <div
                                    style={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                    }}
                                >
                                    {archivo.name}
                                </div>

                                <small>
                                    {(
                                        archivo.size /
                                        (1024 * 1024)
                                    ).toFixed(2)}{" "}
                                    MB
                                </small>
                            </div>

                            <button
                                type="button"
                                onClick={() =>
                                    moverArriba(indice)
                                }
                                disabled={indice === 0}
                            >
                                ↑
                            </button>

                            <button
                                type="button"
                                onClick={() =>
                                    moverAbajo(indice)
                                }
                                disabled={
                                    indice ===
                                    archivos.length - 1
                                }
                            >
                                ↓
                            </button>

                            <button
                                type="button"
                                onClick={() =>
                                    eliminarArchivo(indice)
                                }
                            >
                                ❌
                            </button>

                        </div>
                    ))}

                </div>
            )}

            {/* MENSAJE */}

            {mensaje && (
                <div
                    style={{
                        marginTop: "20px",
                        padding: "12px",
                        borderRadius: "8px",
                        background: "#e8f5e9",
                        color: "#2e7d32",
                    }}
                >
                    {mensaje}
                </div>
            )}

            {/* ERROR */}

            {error && (
                <div
                    style={{
                        marginTop: "20px",
                        padding: "12px",
                        borderRadius: "8px",
                        background: "#ffebee",
                        color: "#c62828",
                    }}
                >
                    {error}
                </div>
            )}

            {/* BOTONES */}

            {archivos.length > 0 && (
                <div
                    style={{
                        display: "flex",
                        gap: "10px",
                        marginTop: "25px",
                    }}
                >

                    <button
                        type="button"
                        onClick={unirPDF}
                        disabled={cargando}
                    >
                        {cargando
                            ? "Uniendo PDF..."
                            : "Unir PDF"}
                    </button>

                    <button
                        type="button"
                        onClick={limpiar}
                        disabled={cargando}
                    >
                        Limpiar
                    </button>



                </div>
            )}

            <Button onClick={volver}>
                Volver
            </Button>

        </div>
    );
};

export default UnirPDF;
